var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.update_key,on:{"click":function($event){$event.preventDefault();return _vm.change_view()}}},[_vm._v(" "+_vm._s(_vm.get_time())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }